<template>
  <div class="expand-item-container">
    <div class="expand-item">
      原不含税单价: {{ row.priceAfterTax }}
    </div>
    <div class="expand-item">
      原不含税总金额: {{ row.totalPriceAfterTax }}
    </div>
    <div class="expand-item">
      原总税金: {{ row.totalTax }}
    </div>
    <div class="expand-item">
      规格: {{ row.specification }}
    </div>
    <div class="expand-item">
      生产厂家: {{ row.manufacturer }}
    </div>
    <div class="expand-item">
      包装单位: {{ row.drugMinimumPackagingUnit }}
    </div>
    <div class="expand-item">
      数量: {{row.num}}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    row: Object,
  },
};
</script>
<style scoped>
</style>
